<template>
  <div>
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card>
      <v-form class="pa-10" ref="form">
        <SelectPeopleList
          :disabled-form="disabledForm"
          :items-selected="personsInCharge"
        />
        <v-divider />
        <UserFormActions
          form_name_text="Modify responsible"
          :form_name="form_name"
          :refForm="$refs.form"
          :object_type="object_type"
          :data="processData"
          :state="state"
          @change-state="changeState"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import SelectPeopleList from "../../reusables/SelectPeopleList";
import changeState from "../../../mixins/changeState";
import investigatorData from "../../../mixins/investigator_data";

export default {
  mixins: [changeState, investigatorData],
  components: { UserFormActions, RejectCommentLayout, SelectPeopleList },
  name: "ModifyResponsibleForm",
  computed: {
    updateForm() {
      return this.$route.meta.updateForm;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      return {
        title: this.investigator.name,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.investigator.id,
        data: {
          user: {
            person: {
              incharge: this.personsInCharge
            }
          }
        }
      };
    }
  },

  created() {
    this.getData();
  },

  data: () => ({
    menu: false,
    object_type: "investigator",
    form_name: "modifyResponsibleForm",
    state: "",
    reject_comment: ""
  }),

  methods: {
    getData() {
      let path = "";
      if (this.updateForm || this.$route.meta.readOnly) {
        path =
          this.$store.state.endpoint +
          "/user/moderatedOperations/investigator/" +
          this.$route.params.id;
        axios
          .get(path)
          .then(response => {
            this.personsInCharge = response.data.data.user.person.incharge;
            this.state = response.data.state;
            this.form_name = response.data.form_name;
            this.reject_comment = response.data.reject_comment;
            this.investigator.id = response.data.object_id;
            this.getInvestigator(
              this.$store.state.endpoint + "/person/" + this.investigator.id
            );
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.getInvestigatorAndPersonsInCharge(
          this.$store.state.endpoint + "/person/" + this.$route.params.id
        );
      }
    }
  }
};
</script>

<style scoped></style>
